import { Component, OnInit, Inject, EventEmitter, DoCheck } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BorrowerRenderingService } from '../../../../../../../services/borrower/borrower-rendering.service';
import { ReviewFormLabel_EN } from 'src/app/models/labels/reviewFormLabel_EN';
import { ReviewFormLabel_HN } from 'src/app/models/labels/reviewFormLabel_HN';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit,DoCheck {
  custName : string;
  label: any;

  constructor( @Inject(DOCUMENT,) private document: Document,private borrowerRenderingService: BorrowerRenderingService) { }
  
  ngDoCheck(): void {
    if (this.borrowerRenderingService.language) {
      if (this.borrowerRenderingService.language === "ENGLISH") {
        this.label = new ReviewFormLabel_EN();
      } else if (this.borrowerRenderingService.language === "HINDI") {
        this.label = new ReviewFormLabel_HN();
      }
    } else {
      this.label = new ReviewFormLabel_EN();
    }
  }

  ngOnInit() {
    if (this.borrowerRenderingService.language) {
      if (this.borrowerRenderingService.language === "ENGLISH") {
        this.label = new ReviewFormLabel_EN();
      } else if (this.borrowerRenderingService.language === "HINDI") {
        this.label = new ReviewFormLabel_HN();
      }
    } else {
      this.label = new ReviewFormLabel_EN();
    }


    this.custName = this.borrowerRenderingService.primaryBorrower.firstName+" "+this.borrowerRenderingService.primaryBorrower.lastName;
    
  }

  thankYouSubmit() {
  
   this.document.location.href = 'https://www.renault.co.in/';
  }

}
